import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.oralbook.editunit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_UNIT_ASYNC: `${uid}.saveUnitAsync`,
    SAVE_UNIT_SUCCESS: `${uid}.saveUnitSuccess`,
    SAVE_UNIT_FAILURE: `${uid}.saveUnitFailure`,
};

export { ActionTypes };
